const IDLE_SECONDS = Number(process.env.REACT_APP_IDLE_SECONDS)
const IDLE_DEBOUNCE = Number(process.env.REACT_APP_IDLE_DEBOUNCE)
const POPUP_SECONDS = Number(process.env.REACT_APP_POPUP_SECONDS)

export {
  IDLE_SECONDS,
  IDLE_DEBOUNCE,
  POPUP_SECONDS
}
